import styled from 'styled-components';

export const IdpMenuLabel = styled.div`
  padding: 0;
  width: 100%;
  a {
    padding: 0;

    padding-top: 5px;
    margin: 0;
    width: 100%;
    border-bottom: 1px solid #ccc;
  }

  img {
    height: 25px;
    width: auto;
    margin: 10px 0 10px 10px;
    border: 0;
  }
  &.only-link {
    a {
      color: #06c;
      padding: 6px 0 6px 10px;
    }
  }
`;
